module.exports = __webpack_public_path__ + "static/img/pass_服务管理.d18d8574.png";